// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.experiments.RentalManagerUserExperimentWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { ExperimentGetDto, ExperimentListDto, ListingAlias } from '../..';

interface GetTreatmentParams {
  featureName: string;
  listingAlias?: ListingAlias;
}

export const RentalManagerUserExperimentWebApiHandler_getTreatment_Path = '/api/web/v1/users/experiments/getTreatment';

/**
 * Get treatment for a given feature name
 */
export const RentalManagerUserExperimentWebApiHandler_getTreatment = (
  getParams: GetTreatmentParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetTreatmentParams, never, ExperimentGetDto>({
    getParams: getParams,
    endpoint: RentalManagerUserExperimentWebApiHandler_getTreatment_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserExperimentWebApiHandler_list_Path = '/api/web/v1/users/experiments/list';

/**
 * Get list of experiments
 */
export const RentalManagerUserExperimentWebApiHandler_list = (environment?: RentalManagerEnvironment) => {
  return frontEndRequestV2<never, never, ExperimentListDto>({
    endpoint: RentalManagerUserExperimentWebApiHandler_list_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
